import { render } from "./Sidebar.vue?vue&type=template&id=2a3a6968"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=2a3a6968&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/navigation/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a3a6968"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a3a6968', __exports__)) {
    console.log('reload')
    api.reload('2a3a6968', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=2a3a6968", () => {
    console.log('re-render')
    api.rerender('2a3a6968', render)
  })

}


export default __exports__